import React from 'react';
import { Link } from 'react-router-dom';

const BlogPosts = ({}) => (
  <div className="hero-body" style={{ backgroundColor: '#6EBDFF' }}>
    <div className="container">
        <div className="columns is-vcentered">
            <div className="column is-6 is-offset-3 is-hero-title has-text-centered">
                <h1 className="title is-1">
                                <Link to="/BlogPosts" style={{ color: '#FFFFFF'}}>Blog</Link>
                            </h1>
                <h2 className="subtitle is-4">
                                Zengin ve dinamik içeriğimize göz atın.
                </h2>
                <div class="help-search-wrapper">
                  <input type="text" placeholder="blogda arayın" />
                    <i class="sl sl-icon-magnifier"></i>
                </div>
            </div>
        </div>
    </div>
</div>
);

export default BlogPosts;
